<template>
  <div id="application" class="application">
    <div class="container">
      <Index />
    </div>
  </div>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import Index from '@template/index.vue';

export default {
  name: 'application',
  components: { // 组件
    Index
  },
  // props: [], // 接收参数
  // emits: [], // 发出参数
  // provide: [], // 发出深层参数
  // inject: [], // 接收深层参数
  // data(): DataInterface { // 数据
  //     return {};
  // },
  // computed: {}, // 计算属性
  // watch: {}, // 侦听器
  // directives: {}, // 自定义指令
  // //----- 生命周期 Start -----//
  // beforeCreate(): void { // 实例化之后，创建之前
  // },
  // created(): void { // 创建之后
  // },
  // beforeMount(): void { // 挂载之前
  // },
  // mounted(): void { // 挂载之后
  // },
  // beforeUpdate(): void { // 更新之前
  // },
  // updated(): void { // 更新之后
  // },
  // activated(): void { // 被 keep-alive 缓存的组件激活时调用
  // },
  // deactivated(): void { // 被 keep-alive 缓存的组件失活时调用
  // },
  // beforeDestroy(): void { // 销毁之前
  // },
  // destroyed(): void { // 销毁之后
  // },
  // errorCaptured(): void { // 后代报错时
  // },
  // //----- 生命周期 End -----//
  // methods: {} // 方法
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

.application {
  overflow: hidden;
  .position();
  width: 100%;
  height: 100%;
  background: @color_1;
  
  > .container {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
  }
}
</style>